module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper short-contents"
  }, [_c('app-header'), _c('div', {
    staticClass: "container bg02 txtC moral-message short-contents"
  }, [_c('div', {
    staticClass: "moral-message__sec01"
  }, [_c('h2', {
    staticClass: "fz18 bold mb15 brown"
  }, [_vm._v("回答ありがとうだニャン♪")]), _c('p', {
    staticClass: "mb15 fz13"
  }, [_vm._v("今月のモラルチェックを送信しました。")]), _vm._m(0), _c('p', {
    staticClass: "btn-link"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_c('span', [_vm._v("トップページへ戻る")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moral-message__sec01__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_05.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88c2a29c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/message-sent.pug
// module id = 1443
// module chunks = 1